if (!customElements.get('sa-form-collaboration')) {
  class SaFormCollaboration extends HTMLElement {
    constructor() {
      super();
      this.handleSubmit = this.handleSubmit.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init());
      } else {
        this.init();
      }
    }

    init() {
      this.form = this.querySelector('#collaboration-form');
      if (!this.form) return;

      this.initCheckboxGroups();
      this.initBlockVisibility();
      this.initFormSubmit();
    }

    initCheckboxGroups() {
      this.querySelectorAll('.collab-block--checkbox').forEach(block => {
        const hidden = block.querySelector('input[type="hidden"]');
        const checkboxes = block.querySelectorAll('input[type="checkbox"]');
        if (!hidden || !checkboxes.length) return;

        const sync = () => {
          hidden.value = Array.from(checkboxes)
            .filter(cb => cb.checked)
            .map(cb => cb.value)
            .join(', ');
        };

        checkboxes.forEach(cb => {
          cb.addEventListener('change', () => {
            checkboxes.forEach(box => box.setCustomValidity(''));
            sync();
          });
        });
        sync();
      });
    }

    initBlockVisibility() {
      const dependents = this.querySelectorAll('[data-visible-when-field]');
      if (!dependents.length) return;

      const fieldMap = {};
      this.querySelectorAll('[data-block-field]').forEach(block => {
        fieldMap[block.dataset.blockField] = block;
      });

      dependents.forEach(block => {
        const controlFieldName = block.dataset.visibleWhenField;
        const triggerValues = block.dataset.visibleWhenValues.split(',').map(v => v.trim());
        const controlBlock = fieldMap[controlFieldName];
        if (!controlBlock) return;

        const getSelectedValues = () => {
          const select = controlBlock.querySelector('select');
          if (select) return select.value ? [select.value] : [];
          return Array.from(controlBlock.querySelectorAll('input[type="checkbox"]'))
            .filter(cb => cb.checked)
            .map(cb => cb.value);
        };

        const update = () => {
          const shouldShow = triggerValues.some(v => getSelectedValues().includes(v));
          const inputs = block.querySelectorAll('input, select, textarea');

          if (shouldShow) {
            block.style.display = '';
            inputs.forEach(i => (i.disabled = false));
          } else {
            block.style.display = 'none';
            inputs.forEach(i => {
              i.disabled = true;
              i.setCustomValidity('');
            });
          }
        };

        const select = controlBlock.querySelector('select');
        if (select) {
          select.addEventListener('change', update);
        } else {
          controlBlock.querySelectorAll('input[type="checkbox"]').forEach(cb => {
            cb.addEventListener('change', update);
          });
        }
        update();
      });
    }

    initFormSubmit() {
      const submitBtn = this.form.querySelector('.form-submit');
      if (submitBtn) {
        submitBtn.addEventListener('click', () => {
          this.validateCheckboxGroups();
          this.scrollToFirstInvalid();
        });
      }
      this.form.addEventListener('submit', this.handleSubmit);
    }

    scrollToFirstInvalid() {
      const firstInvalid = this.form.querySelector(':invalid');
      if (!firstInvalid) return;
      const block = firstInvalid.closest('.collab-block, .form-group');
      const target = block || firstInvalid;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    validateCheckboxGroups() {
      this.querySelectorAll('.collab-block--checkbox').forEach(block => {
        if (block.style.display === 'none') return;
        const container = block.querySelector('.checkbox-group-vertical');
        if (!container || !container.dataset.msgRequired) return;

        const checkboxes = block.querySelectorAll('input[type="checkbox"]');
        const anyChecked = Array.from(checkboxes).some(cb => cb.checked);
        if (!anyChecked && checkboxes.length) {
          checkboxes[0].setCustomValidity(container.dataset.msgRequired);
        }
      });
    }

    handleSubmit(e) {
      const submitBtn = this.form.querySelector('.form-submit');
      if (submitBtn) {
        if (submitBtn.dataset.submitting === 'true') {
          e.preventDefault();
          return;
        }
        submitBtn.textContent = submitBtn.dataset.submittingLabel || 'Sending...';
        submitBtn.dataset.submitting = 'true';
      }
    }

    disconnectedCallback() {}
  }

  customElements.define('sa-form-collaboration', SaFormCollaboration);
}
